var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Navigation_rechts"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Navigation_rechts",
    "data-name": "Navigation rechts",
    clipPath: "url(#clip-Navigation_rechts)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rechts_Kreis",
    "data-name": "rechts + Kreis",
    transform: "translate(2 2)",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_669",
    "data-name": "Gruppe 669"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_98",
    "data-name": "Ellipse 98",
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_667",
    "data-name": "Gruppe 667",
    transform: "translate(-18.398 -10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_471",
    "data-name": "Gruppe 471",
    transform: "translate(21 47.6) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_36",
    "data-name": "Pfad 36",
    d: "M19.616,0,9.81,9.814,0,0",
    transform: "translate(2.984 17.398)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.df7a270303b9e7145d7600e06b22d487.svg";
export { ForwardRef as ReactComponent };